import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface ErrorProps {
  errorMessage?: string;
}

const Error: React.FC<ErrorProps> = ({ errorMessage }) => {
  const { t } = useTranslation();
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowErrorMessage(true);
    }, 4000); 

    return () => clearTimeout(timeout);
  }, []);

  return (
    <ErrorContainer>
      {showErrorMessage && <p>{t(errorMessage || '', t('errors.somethingWentWrong'))}</p>}
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  width: fit-content;
  margin: 0 auto;
`;

export default Error;
